import { FORM_INPUT_REF_DELAY } from 'pages/Login/components/LogInForm/constants';

const giveFocusToInput = (inputRef: React.RefObject<HTMLInputElement>) => {
  if (inputRef.current) {
    inputRef.current.focus();
  }
};

// Ensure to use this return function in a useEffect cleanup to avoid memory leaks.
const giveFocusToInputWithDelay = (inputRef: React.RefObject<HTMLInputElement>) => {
  const timer = setTimeout(() => {
    giveFocusToInput(inputRef);
  }, FORM_INPUT_REF_DELAY);
  return () => clearTimeout(timer);
};

export { giveFocusToInput, giveFocusToInputWithDelay };
